import { Address } from '../global/interfaces/address';

export class AddressFunctions {
  getEmptyOrFormatExistingAddress(address?: Address): Address {
    return {
      id: address?.id ?? '',
      streetNumber: address?.streetNumber ?? '',
      street: address?.street ?? '',
      city: address?.city ?? '',
      state: address?.state ?? '',
      country: address?.country ?? '',
      postalCode: address?.postalCode ?? '',
      latitude: address?.latitude ?? 0,
      longitude: address?.longitude ?? 0,
      title: address?.title ?? '',
      iso3: address?.iso3 ?? '',
      note: address?.note ?? '',
      timezone: address?.timezone ?? '',
    };
  }

  isValidCoordinate(coordinate: number) {
    return !!coordinate || coordinate === 0;
  }

  isValidContractAddress(address?: Address) {
    return (this.isValidCoordinate(address?.latitude) && this.isValidCoordinate(address?.longitude)) || !!address?.iso3;
  }

  addressToString(address?: Address, format: string = 'full') {
    if (!address) return '';

    const postalCode = (address.postalCode ?? '').trim();
    const regionCode = (address.regionCode ?? '').trim();
    const city = (address.city ?? '').trim();
    const country = (address.country ?? '').trim();
    const street = (address.street ?? '').trim();

    if (format === 'city') {
      return city ?? postalCode;
    }

    if (!postalCode && !city && !country && !street) return '';

    if (!postalCode && !city && !street && regionCode) return regionCode;

    const streetNumber = `${address.streetNumber ?? ''}`.trim();
    const streetNumberNotZero = streetNumber === '0' ? '' : streetNumber;
    const streetAndNumber = [streetNumberNotZero, street].filter(Boolean).join(' ');
    return [streetAndNumber, city, postalCode, country].filter(Boolean).join(', ');
  }

  addressToRegionCode(address: Address) {
    return `${address.country?.toUpperCase()}-${address.postalCode?.slice(0, 2)}`;
  }
}
